<nav aria-label="Breadcrumb" class="breadcrumbs">
  <ol class="flex flex-wrap items-center gap-1 text-xs sm:text-sm">
    @for (item of items(); track $index) {
      <li class="flex items-center gap-1">
        @if (item.route) {
          <a
            [routerLink]="item.route"
            class="rounded-md px-1.5 py-0.5 text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
          >
            {{ item.label }}
          </a>
        } @else {
          <span class="rounded-md bg-slate-100 px-1.5 py-0.5 font-semibold text-slate-900">
            {{ item.label }}
          </span>
        }

        @if (!$last) {
          <span aria-hidden="true" class="px-1 text-slate-400">/</span>
        }
      </li>
    }
  </ol>
</nav>
